module.exports = __webpack_public_path__ + "static/media/championRabbit_300-200.2065b8a3.png";